import { Badge, BadgeProps, Text } from '@cmpsr/components';

type AverageBadgeProps = BadgeProps & {
  isRisk?: boolean;
};

export default function AverageBadge({ isRisk, ...props }: AverageBadgeProps) {
  const text = isRisk ? 'Average Risk' : 'Average';

  return (
    <Badge w="max-content" backgroundColor="alert-warning-default" py="2px" {...props}>
      <Text color="text-warning" variant="text-body-floating-label-bold" textTransform="capitalize">
        {text}
      </Text>
    </Badge>
  );
}
